import React, { useState } from "react";
import "./App.css";

import Header from "./components/Home/Header.jsx";
import Home from "./components/Home/Home.jsx";
import Login from "./components/Login/Login.jsx";
import Sidebar from "./components/Home/Sidebar/Sidebar.jsx";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

function App() {
  //Create a state of the sidebar. By default, this state is false
  const [isOpen, setIsOpen] = useState(false);

  // On the click, gonna change the state
  const toggle = () => {
    //Change the state of the openned
    setIsOpen(!isOpen);
  };

  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact path="/">
            <Header toggle={toggle} />
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <Home isOpen={isOpen}/>
          </Route>
          <Route exact path="/login">
            <Login />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
